import { EventTarget } from 'types/common.types';

export const normalizeOnChangeValue = (event: EventTarget) => {
  if (!Array.isArray(event)) {
    event.target.value = event.target.value[0];
    return event;
  }
  return event;
};
